import React from 'react';

import Button from "components/CustomButtons/Button.jsx";
import { Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from '@material-ui/core';
import ReactSelect from 'components/Select/ReactSelect';
import Api from 'api/Api.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { connect } from 'react-redux';
import CustomerEndpoints from 'api/CustomerEndpoints';
import AccountImage from 'components/Image/AccountImage';

class AddCustomerModal extends React.Component {

    state = {
        loading: false,
        selectedCustomer: { label: 'None', value: null }
    }
    //AddCustomerModal
    submit() {
        this.setState({ loading: true }, () =>
            Api.get(CustomerEndpoints.addProduct, { customer_id: this.state.selectedCustomer.value, product_id: this.props.product_id })
                .then(({ data }) => {
                    console.log(data);
                    this.props.onClose();
                    this.props.refresh();
                    this.setState({ loading: false, selectedCustomer: { label: 'None', value: null } })
                })
                .catch((e) => this.setState({ loading: false }, () => console.error(e)))
        );
    }

    render() {
        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.onClose}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
                PaperProps={{ style: { overflow: 'visible' } }}
            >
                <DialogTitle id="form-dialog-title">Add Customer to Product</DialogTitle>
                <DialogContent style={{ overflow: 'visible' }}>
                    <ReactSelect
                        options={
                            [
                                { label: 'None', value: null }
                            ]
                                .concat(
                                    this.props.customers
                                        .filter(customer => !this.props.existing_customers.some(x => x.id === customer.id))
                                        .map(customer => ({ avatar: <AccountImage {...customer} />, label: customer.account_no + " " + customer.name, value: customer.id }))
                                )
                        }
                        onChange={(value) => this.setState({ selectedCustomer: value })}
                        placeholder="No Customer Selected"
                        value={this.state.selectedCustomer}
                        isSearchable
                        isLoading={this.state.loading}
                        isDisabled={this.state.loading}
                    />
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.onClose} color="rose" simple>
                        Cancel
                    </Button>


                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.submit()}
                                color="rose"
                                round
                                disabled={this.state.selectedCustomer.value === null}
                            >
                                Add Customer
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return ({
        customers: state.customers.list
    });
}

export default connect(mapStateToProps)(AddCustomerModal);